import { api } from "../common/utils"
import { BRAND_SMS_SETTINGS_ENDPOINT } from "../common/constants"

export interface BrandSmsSettings {
  brand_id: number
  agent_name: string
  send_initial_summary: boolean
  send_dashboard_link: boolean
}

export interface BrandSmsSettingsResponse {
  status: "success" | "error"
  message?: string
  settings?: BrandSmsSettings
}

export interface UpdateBrandSmsSettingsPayload {
  brand_id: number
  agent_name?: string
  send_initial_summary?: boolean
  send_dashboard_link?: boolean
}

const brandSmsSettingsApi = {
  get: (brandId: number | string): Promise<BrandSmsSettingsResponse> =>
    api
      .get(BRAND_SMS_SETTINGS_ENDPOINT, { params: { brand_id: brandId } })
      .then(r => r.data),
  update: (
    payload: UpdateBrandSmsSettingsPayload
  ): Promise<BrandSmsSettingsResponse> =>
    api.post(BRAND_SMS_SETTINGS_ENDPOINT, payload).then(r => r.data)
}

export default brandSmsSettingsApi
